"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = propertyOf;
var _noop = _interopRequireDefault(require("./noop.js"));
var _get = _interopRequireDefault(require("./get.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return _noop.default;
  return function (path) {
    return (0, _get.default)(obj, path);
  };
}